import React, { FC, useContext } from 'react';

import { WhitePaperFormContext } from 'buyside/components/presentation/WhitePaperForm/whitePaperForm';
import CheckboxField from 'buyside/components/presentation/Fields/checkboxField';
import EmployerField from 'buyside/components/presentation/ResearchFormWizard/SharedFields/employerField';
import FundProfileDisplayField from 'buyside/components/presentation/ResearchFormWizard/SharedFields/fundProfileDisplayField';
import PositionDisclaimerFundField from 'buyside/components/presentation/ResearchFormWizard/SharedFields/positionDisclaimerFundField';
import ResearchFormWizardSection from 'buyside/components/presentation/ResearchFormWizard/researchFormWizardSection';
import RequiredDisclaimerFields from 'buyside/components/presentation/ResearchFormWizard/SharedFields/requiredDisclaimerFields';

const { whitePaperOptionalDisclaimers } = require('buyside/util/constantsFromRails.json');

const Disclaimers: FC = () => {
  const { currentUser, isDraft } = useContext(WhitePaperFormContext);

  if (!currentUser) throw new Error();

  const { currentEmployers } = currentUser;

  return (
    <>
      <ResearchFormWizardSection title="Optional Disclosures and Visibility on Site">
        <CheckboxField
          label={whitePaperOptionalDisclaimers.positionDisclaimerIndividual}
          name="positionDisclaimerIndividual"
          size="small"
        />
        {currentEmployers.length ? (
          <>
            <EmployerField currentEmployers={currentEmployers} isDraft={isDraft} />
            <PositionDisclaimerFundField
              label={whitePaperOptionalDisclaimers.positionDisclaimerFund}
            />
            <FundProfileDisplayField
              currentEmployers={currentEmployers}
              researchType="Macro/Thematic Report"
            />
          </>
        ) : null}
      </ResearchFormWizardSection>
      <ResearchFormWizardSection title="Required Legal Disclosures">
        <RequiredDisclaimerFields />
      </ResearchFormWizardSection>
    </>
  );
};

export default Disclaimers;
